function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", {
  id: "defs4360"
}, React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath4370"
}, React.createElement("path", {
  d: "M 0,512 H 512 V 0 H 0 Z",
  id: "path4368"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  id: "bg",
  x: 0,
  y: 0,
  width: "100%",
  height: "100%",
  fill: "white"
});

var SvgMotivation = function SvgMotivation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "svg4356",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("mask", {
    id: "custom"
  }, _ref3, React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, React.createElement("path", {
    transform: "matrix(1,0,0,1,246,166)",
    d: "m 0,0 c 5.52,0 10,-4.48 10,-10 0,-5.52 -4.48,-10 -10,-10 -5.52,0 -10,4.48 -10,10 0,5.52 4.48,10 10,10",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4374"
  }))), React.createElement("g", {
    mask: "url(#custom)"
  }, React.createElement("g", {
    id: "g4362",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, React.createElement("g", {
    id: "g4364"
  }, React.createElement("g", {
    id: "g4366",
    clipPath: "url(#clipPath4370)"
  }, React.createElement("g", {
    id: "g4372",
    transform: "translate(246,166)"
  }, React.createElement("path", {
    d: "m 0,0 c 5.52,0 10,-4.48 10,-10 0,-5.52 -4.48,-10 -10,-10 -5.52,0 -10,4.48 -10,10 0,5.52 4.48,10 10,10",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4374"
  })), React.createElement("g", {
    id: "g4376",
    transform: "translate(326,332)"
  }, React.createElement("path", {
    d: "M 0,0 C 0,16.57 13.43,30 30,30 38.28,30 45.78,26.64 51.21,21.21 56.64,15.78 60,8.28 60,0 v -36",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4378"
  })), React.createElement("g", {
    id: "g4380",
    transform: "translate(386,266)"
  }, React.createElement("path", {
    d: "m 0,0 c 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 v 20",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4382"
  })), React.createElement("g", {
    id: "g4384",
    transform: "translate(326,286)"
  }, React.createElement("path", {
    d: "m 0,0 c 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 v 66 c 0,16.57 13.43,30 30,30 8.28,0 15.78,-3.36 21.21,-8.79 C -3.36,81.78 0,74.28 0,66 Z",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4386"
  })), React.createElement("g", {
    id: "g4388",
    transform: "translate(206,352)"
  }, React.createElement("path", {
    d: "M 0,0 C 0,16.57 13.43,30 30,30 38.28,30 45.78,26.64 51.21,21.21 56.64,15.78 60,8.28 60,0",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4390"
  })), React.createElement("g", {
    id: "g4392",
    transform: "translate(146,290.6504)"
  }, React.createElement("path", {
    d: "m 0,0 v 61.35 c 0,16.57 13.43,30 30,30 16.57,0 30,-13.43 30,-30 v -56",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4394"
  })), React.createElement("g", {
    id: "g4396",
    transform: "translate(186,236)"
  }, React.createElement("path", {
    d: "M 0,0 H 20 C 53.14,0 80,26.86 80,60 H -20 C -27.28,60 -34.11,58.05 -40,54.65 -51.96,47.73 -60,34.8 -60,20 c 0,-25.18 5.93,-49.62 16.89,-71.55 10.97,-21.93 26.97,-41.34 47.11,-56.45 5.04,-3.78 9.04,-8.63 11.78,-14.11 C 18.52,-127.59 20,-133.7 20,-140 v -86 h 160 v 86 c 6.62,19.87 11.62,40.21 14.97,60.82 3.34,20.61 5.03,41.48 5.03,62.43 V 60",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4398"
  })), React.createElement("g", {
    id: "g4400",
    transform: "translate(196,236)"
  }, React.createElement("path", {
    d: "M 0,0 C 24.26,0 44.48,-17.27 49.04,-40.19",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4402"
  })), React.createElement("g", {
    id: "g4404",
    transform: "translate(206,76)"
  }, React.createElement("path", {
    d: "M 0,0 H 160",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4406"
  })), React.createElement("g", {
    id: "g4408",
    transform: "translate(266,502)"
  }, React.createElement("path", {
    d: "M 0,0 V -60",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4410"
  })), React.createElement("g", {
    id: "g4412",
    transform: "translate(378.6299,478.7803)"
  }, React.createElement("path", {
    d: "M 0,0 -42.42,-42.431",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4414"
  })), React.createElement("g", {
    id: "g4416",
    transform: "translate(159.2202,484.6299)"
  }, React.createElement("path", {
    d: "M 0,0 42.43,-42.42",
    style: {
      fill: "none",
      stroke: "#cdcdcd",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4418"
  })))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMotivation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/motivation.1b359018.svg";
export { ForwardRef as ReactComponent };